import { useAuth } from '../contexts/AuthContext';
import { useMoolah } from '../contexts/MoolahContext';

/**
 * Returns true when the user has a visible wallet balance but is below KYC
 * Tier 1 (unified Tier 0 policy: wallet credited before KYC verify, spend
 * locked until Tier 1 — funds sit safely until KYC, no auto-reversal).
 *
 * Use to show the explainer banner/modal and as a client-side guard for spend
 * actions. The backend remains the source of truth — all outbound routes are
 * gated by requireActiveWalletAtTier(1) which returns KYC_TIER_REQUIRED.
 */
export interface RestrictedWalletCreditState {
  isRestricted: boolean;
  balance: number;
  kycTier: number;
  kycStatus: string;
}

export function useRestrictedWalletCredit(): RestrictedWalletCreditState {
  const { user } = useAuth();
  const { balance } = useMoolah();
  const kycTier = user?.kycTier ?? 0;
  const kycStatus = user?.kycStatus ?? 'not_started';
  const isRestricted = balance > 0 && kycTier < 1 && kycStatus !== 'verified';
  return { isRestricted, balance, kycTier, kycStatus };
}
